import React from 'react';
import { Field } from 'react-final-form';
import { IconSpinner } from '../../components';
import { useIntl } from '../../util/reactIntl';

import css from './FieldUploadFile.module.css';
import classNames from 'classnames';

const FieldUploadFile = props => {

  const {
    savedDocuments,
    setSavedDocuments,
    form,
    onUploadFile,
    inProgress,
    label,
    userId,
    entityId,
    fieldClassName,
    type,
    ...rest
  } = props;

  const intl = useIntl();

  return (

    <Field form={null} {...rest}>
      {fieldprops => {
        const { accept, input, disabled: fieldDisabled } = fieldprops;
        const { name } = input;

        const onChange = e => {
          const file = e.target.files[0];

          if (e.target.files?.length > 1) {
            alert(intl.formatMessage({ id: 'FieldUploadFile.invalidFileLimit' }));
            e.target.value = null;
            return;
          }

          if (!accept.includes(file.type)) {
            alert(intl.formatMessage({ id: 'FieldUploadFile.invalidFileFormat' }));
            e.target.value = null;
            return;
          }

          form.change(name, file);
          form.blur(name);

          onUploadFile(file, name, type, userId, entityId)
            .then(response => {
              setSavedDocuments(response);
            })
            .catch(e => {
              console.log(e);
            });

          e.target.value = null;
        };

        const inputProps = { accept, id: name, name, onChange, type: "file" };

        return (
          <div className={classNames(css.addImageWrapper, fieldClassName)}>
            {fieldDisabled ? null : <input {...inputProps} className={css.addImageInput} />}
            <label htmlFor={name} className={css.addImage}>
              {inProgress ? < IconSpinner /> : label}
            </label>
          </div>
        );
      }}
    </Field>
  );
};

export default FieldUploadFile;
